import React from 'react';
import { HeartIcon } from 'lucide-react';
export function Logo() {
  return <div className="flex items-center gap-2" data-id="element-48">
      <div className="bg-gradient-to-br from-pink-400 to-purple-500 rounded-full p-1.5" data-id="element-49">
        <HeartIcon className="w-5 h-5 text-white fill-white" data-id="element-50" />
      </div>
      <span className="text-xl font-bold bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent" data-id="element-51">
        Lola
      </span>
    </div>;
}